/**
 * Kategori çevirileri için utility fonksiyonları
 * ProductDetail, Checkout ve diğer sayfalarda kullanılabilir
 */

/**
 * Kategori value'sunu Türkçe label'a çevirir
 * @param {string} categoryValue - Kategori değeri (örn: 'figurine', 'decoration')
 * @returns {string} Türkçe kategori ismi
 */
export const getCategoryLabel = (categoryValue) => {
  const categories = {
    'figurine': 'Figür',
    'decoration': 'Dekorasyon',
    'toys': 'Oyuncak',
    'jewelry': 'Takı & Aksesuar',
    'art': 'Sanat',
    'game': 'Oyun & Hobi',
    'tech': 'Teknoloji',
    'tools': 'Araç & Gereç',
    'household': 'Ev Eşyası',
    'educational': 'Eğitim',
    'other': 'Diğer'
  };
  
  return categories[categoryValue] || categoryValue;
};

/**
 * Tüm kategori çevirilerini döndürür
 * @returns {Object} Kategori value → label mapping objesi
 */
export const getAllCategoryLabels = () => {
  return {
    'figurine': 'Figür',
    'decoration': 'Dekorasyon',
    'toys': 'Oyuncak',
    'jewelry': 'Takı & Aksesuar',
    'art': 'Sanat',
    'game': 'Oyun & Hobi',
    'tech': 'Teknoloji',
    'tools': 'Araç & Gereç',
    'household': 'Ev Eşyası',
    'educational': 'Eğitim',
    'other': 'Diğer'
  };
};
